// features/ups/modals/AddAccountModal.js
// Click-to-open modal to create an account for a specific agency (role, username, email, password) and submit via createAccount, then close on success.
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { createAccount } from '../../agencyAccounts/agencyAccountsSlice';

export default function AddAccountModal({ isOpen, onClose, agency }) {
  const dispatch = useDispatch();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const [role, setRole] = useState('agency_user');
  const [username, setUsername] = useState('');
  const [email, setEmail]     = useState('');
  const [password, setPassword] = useState('');

  const canCreate = username.trim() && email.trim() && password;

  const handleCreate = async () => {
    if (!canCreate || busy) return;
    setBusy(true); setError('');
    try {
      await dispatch(createAccount({
        agencyId: agency.id, role, username: username.trim(), email: email.trim(), password
      })).unwrap();
      onClose();
    } catch (e) {
      setError(typeof e === 'string' ? e : 'Failed to create account');
    } finally {
      setBusy(false);
    }
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-xl w-full max-w-lg shadow-lg" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">Add account — {agency?.name}</h3>
          <button onClick={onClose} className="p-1 rounded hover:bg-gray-100"><X size={18} /></button>
        </div>
        <div className="p-4 space-y-4">
          <div>
            <label className="block text-sm mb-1">Role</label>
            <select className="w-full border rounded px-3 py-2" value={role} onChange={e => setRole(e.target.value)}>
              <option value="agency_admin">Agency Admin</option>
              <option value="agency_user">Agency User</option>
            </select>
          </div>
          <div>
            <label className="block text-sm mb-1">Username</label>
            <input className="w-full border rounded px-3 py-2" value={username} onChange={e => setUsername(e.target.value)} />
          </div>
          <div>
            <label className="block text-sm mb-1">Email</label>
            <input type="email" className="w-full border rounded px-3 py-2" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="block text-sm mb-1">Password</label>
            <input type="password" className="w-full border rounded px-3 py-2" value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          {error && <div className="text-red-600 text-sm">{error}</div>}
        </div>
        <div className="p-4 border-t flex items-center justify-end">
          <button onClick={onClose} className="px-3 py-2 rounded bg-gray-100 hover:bg-gray-200 mr-2">Cancel</button>
          <button disabled={!canCreate || busy} onClick={handleCreate} className="px-3 py-2 rounded bg-blue-600 text-white disabled:opacity-60">
            {busy ? 'Creating…' : 'Create'}
          </button>
        </div>
      </div>
    </div>
  );
}
